module.exports = __webpack_public_path__ + "img/turfy2_mem@2x.07e516fe.png";